<div class="filter" [ngStyle]="{ width: filterConfig.width ? filterConfig.width : 'auto' }">
  @if (filterConfig?.filterTitle) {
    <label class="filter-label">
      {{ !filterConfig?.translated ? filterConfig?.filterTitle : ("filters." + filterConfig?.filterTitle | translate) }}
    </label>
  }

  <div class="filter-input">
    @switch (filterConfig.inputType) {
      @case ("single-select") {
        <nz-select
          [nzMenuItemSelectedIcon]="null"
          nzPlaceHolder="{{
            !filterConfig?.translated ? filterConfig?.filterTitle : ('filters.' + filterConfig?.filterTitle | translate)
          }}"
          [nzShowArrow]="true"
          nzShowSearch
          [nzMaxTagCount]="0"
          [nzNotFoundContent]="noData"
          [nzLoading]="false"
          [nzSize]="filterConfig?.selectSize || 'large'"
          [nzDropdownMatchSelectWidth]="false"
          nzDropdownClassName="filter-dropdown"
          name="selectSingleFilter"
          ngDefaultControl
          [(ngModel)]="selectedOptions"
          (ngModelChange)="changeSelect($event)"
        >
          @for (option of filterConfig?.selectList; track option) {
            <nz-option [nzValue]="option[filterConfig.property]" [nzLabel]="option.value"></nz-option>
          }
        </nz-select>
      }

      @case ("multi-select") {
        @for (opt of filterConfig?.selectList; track opt) {
          <button
            nz-button
            nzType="default"
            class="mx-0 multi-buttons"
            [ngClass]="{ 'selected-buttons': opt.selected }"
            (click)="changeChoice(opt[filterConfig?.property])"
          >
            {{ opt.value }}
          </button>
        }
      }

      @case ("group-dropdown") {
        <nz-select
          [nzMenuItemSelectedIcon]="null"
          nzPlaceHolder="{{
            !filterConfig?.translated ? filterConfig?.filterTitle : ('filters.' + filterConfig?.filterTitle | translate)
          }}"
          [nzShowArrow]="true"
          nzShowSearch
          [nzMaxTagCount]="0"
          [nzNotFoundContent]="noData"
          [nzLoading]="false"
          [nzSize]="filterConfig?.selectSize || 'large'"
          [nzDropdownMatchSelectWidth]="false"
          nzDropdownClassName="filter-dropdown"
          name="selectGroupFilter"
          ngDefaultControl
          [nzAllowClear]="changeGrouped"
          [(ngModel)]="selectedOptions"
          (ngModelChange)="changeSelect($event)"
        >
          @for (option of filterConfig?.selectList; track option) {
            <nz-option-group
              [nzLabel]="option.value + (filterConfig?.subCode ? ' (' + option[filterConfig?.subCode].value + ')' : '')"
            >
              @for (subOption of option.properties; track subOption) {
                <nz-option [nzValue]="subOption.id" [nzLabel]="subOption.value"></nz-option>
              }
            </nz-option-group>
          }
        </nz-select>
      }

      @case ("multi-group-dropdown") {
        <nz-select
          class="multi-group-drodown"
          #select
          [nzMode]="'multiple'"
          [nzMenuItemSelectedIcon]="null"
          nzPlaceHolder="{{
            !filterConfig?.translated ? filterConfig?.filterTitle : ('filters.' + filterConfig?.filterTitle | translate)
          }}"
          [nzShowArrow]="true"
          nzShowSearch
          [nzMaxTagCount]="0"
          [nzMaxTagPlaceholder]="maxTagsSelected"
          [nzAllowClear]="selectedOptions.length"
          [nzNotFoundContent]="noData"
          [nzLoading]="false"
          [nzSize]="filterConfig?.selectSize || 'large'"
          [nzDropdownMatchSelectWidth]="false"
          nzDropdownClassName="filter-dropdown"
          name="selectFilter"
          ngDefaultControl
          nzCustomContent
          [ngModel]="selectedOptions"
          (ngModelChange)="onGroupChange($event)"
        >
          @if (filterConfig?.selectList?.length && filterConfig?.multiSelect) {
            <nz-option [nzCustomContent]="true" [nzValue]="'all'">
              <div class="option">
                <span class="nz-checkbox-wrapper">
                  @if (filterConfig?.multiSelect) {
                    <label
                      nz-checkbox
                      [nzValue]="'all'"
                      [ngModel]="checkAll"
                      (ngModelChange)="selectGroup(!checkAll, $event, 'all', 'all')"
                    ></label>
                  }
                </span>
                <span class="nz-label">{{ "filters.All" | translate }}</span>
              </div>
            </nz-option>
          }

          @for (option of filterConfig?.selectList; track option) {
            <nz-option-group [nzLabel]="multiGrouping">
              @for (subOption of option.properties; track subOption) {
                <nz-option [nzValue]="subOption.id" [nzLabel]="subOption.value" [nzCustomContent]="true">
                  <div class="multi-grouped ml-1">
                    <span class="nz-checkbox-wrapper mr-4">
                      <label
                        nz-checkbox
                        (ngModelChange)="selectGroup($event, subOption[filterConfig.property], 'option', option)"
                        [nzValue]="subOption[filterConfig.property]"
                        [ngModel]="subOption.selected || option.selected"
                      ></label>
                    </span>
                    <span class="nz-label">{{ subOption?.value }}</span>
                  </div>
                </nz-option>
              }
            </nz-option-group>
            <ng-template #multiGrouping>
              <span class="nz-checkbox-wrapper render-grouped">
                <label
                  nz-checkbox
                  (ngModelChange)="selectGroup($event, option.id, 'group')"
                  [nzValue]="option.id"
                  [ngModel]="option.selected"
                ></label>
              </span>
              <span class="nz-label">
                {{ option.value + (filterConfig?.subCode ? " (" + option[filterConfig?.subCode].value + ")" : "") }}
              </span>
            </ng-template>
          }
        </nz-select>
      }

      @case ("dropdown") {
        <div>
          <nz-select
            #select
            [nzMode]="filterConfig?.multiSelect ? 'multiple' : 'default'"
            nzPlaceHolder="{{
              !filterConfig?.translated
                ? filterConfig?.filterTitle
                : ('filters.' + filterConfig?.filterTitle | translate)
            }}"
            [nzShowArrow]="true"
            nzShowSearch
            [nzMaxTagCount]="0"
            [nzMaxTagPlaceholder]="maxTagsSelected"
            [nzAllowClear]="selectedOptions?.length"
            [nzNotFoundContent]="noData"
            [nzLoading]="false"
            [nzSize]="filterConfig?.selectSize || 'large'"
            [nzDropdownMatchSelectWidth]="false"
            nzDropdownClassName="filter-dropdown"
            name="selectFilter"
            ngDefaultControl
            (nzOnClear)="onClearSelect(filterConfig?.queryName)"
            [(ngModel)]="selectedOptions"
            (ngModelChange)="changeSelect($event)"
          >
            @if (filterConfig?.selectList?.length && filterConfig?.multiSelect) {
              <nz-option nzValue="all" [nzLabel]="'All'"></nz-option>
            }
            @for (option of filterConfig?.selectList; track option) {
              <nz-option [nzValue]="option[filterConfig.property]" [nzLabel]="option[filterConfig.value]"></nz-option>
            }
          </nz-select>
        </div>
      }
    }
  </div>
</div>

<ng-template #noData>
  <nz-empty [nzNotFoundContent]="contentTpl"></nz-empty>
  <ng-template #contentTpl>
    <strong>{{ "filters.noData" | translate }}</strong>
  </ng-template>
</ng-template>

<!-- when user select maximum tags -->
<ng-template #maxTagsSelected> {{ "filters.selectedItems" | translate }}</ng-template>
